import produce from "immer";
import { create } from "zustand";
import { DEFAULT_FILTERS } from "../constants";

export const usePilotageRhStore = create((set) => ({
    /* period: clé API ; agency_id / manager_id / department_id : ids ou null (= tous) */
    filters: { ...DEFAULT_FILTERS },
    /* map sectionId -> bool : comparaison "vs précédent" activée */
    compare: {},
    /* panneau "Personnaliser l'affichage" ; sectionId : section à faire défiler à l'ouverture */
    prefPanel: { open: false, sectionId: null },

    setFilter: (key, value) =>
        set(
            produce((state) => {
                state.filters[key] = value;
            })
        ),
    resetFilters: () =>
        set(
            produce((state) => {
                state.filters = { ...DEFAULT_FILTERS };
            })
        ),
    toggleCompare: (sectionId) =>
        set(
            produce((state) => {
                state.compare[sectionId] = !state.compare[sectionId];
            })
        ),
    openPrefPanel: (sectionId = null) =>
        set({ prefPanel: { open: true, sectionId } }),
    closePrefPanel: () =>
        set(
            produce((state) => {
                state.prefPanel.open = false;
            })
        ),
}));
